<template>
  <div class="loading-wrap-root">
    <img :src="loadImg" class="loading-img">
    <p class="loading-text">{{loadingText}}</p>
  </div>
</template>

<script>
import loadImg from "@/assets/images/loading-bubbles.svg";

export default {
  name: "Loading",
  data() {
    return {
      loadImg,
    }
  },
  props: {
    loadingText: {
      type: String,
      default: "努力加载中..."
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'

.loading-wrap-root
  position absolute
  z-index 99
  top 0
  bottom 0
  right 0
  left 0
  display flex
  align-items center
  justify-content center
  flex-direction column
  .loading-img
    margin-bottom 15px
    width 60px
    height auto
  .loading-text
    font-size $font_size_big
</style>


